module.exports = __webpack_public_path__ + "media/images/icn-search-grey-33ccb2cdddbd27e73a0540643fb1e654.png";